















































































































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { AppData, CareGiver } from "@/models/app-data";
import { ZipCodeService } from "@/service/zipcode.service";
import { required, requiredIf } from "vuelidate/lib/validators";
import CommonMixin from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { CareGiver2WayneContent } from "@/models/content/caregiver-2-wayne";
import { Address } from "@/models/address";
import PageLoader from "@/components/PageLoader.vue"

@Component({
  components: {
    FooterButton,
    PageLoader
  },
  validations: {
    homeless: {
      required,
    },
    otherLocation: {
      required,
    },
    addressSuggestion: {
      required: requiredIf(function (model: CareGiver2): boolean {
        return model.homeless === false;
      }), 
      validAddress(address: string) {
        const model = this as CareGiver2;

        if (address === "") {
          return true;
        }
        return model.isWayneCounty(model.addressComponents.county) && model.addressIsComplete;
      }, 
    },
    otherAddressComponents: {
      requiredOtherAddress: requiredIf(function (model: CareGiver2): boolean {
        return model.otherLocation === true;
      }),
      validOtherAddress(address: Address) {
        const model = this as CareGiver2;

        if ( model.otherLocation !== true) {
          return true;
        }

        if (model.otherAddressSuggestion === "") {
          return true;
        }

        return model.isWayneCounty(address.county) && model.otherAddressIsComplete;
      },
    },
  },
})
export default class CareGiver2 extends Mixins(CommonMixin) {
  appData = {} as AppData;
  zipcodeService = new ZipCodeService();
  content: CareGiver2WayneContent = {} as CareGiver2WayneContent;
  PercentDone = 20;
  homeless = false;
  otherLocation = false;
  textOrEmailIsChecked = false;
  textDirection = "ltr";
  checkTextAlign = "has-text-left";
  includedZipCodes: Array<string> = [];
  addressSuggestion = "";
  otherAddressSuggestion = "";
  addressComponents = {} as Address;
  addressIsComplete = true
  otherAddressComponents = {} as Address;
  otherAddressIsComplete = true
  pageLoaded = false;

  get autocompleteOptions(): any {
    return {
      componentRestrictions: {
        country: ["US"],
      },
        types: ["address"]
    };
  }

  async mounted(): Promise<void> {
    // Foo test
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getCareGiver2Content();
      this.includedZipCodes = await this.zipcodeService.GetZipCodes();
      this.textDirection = contentService.TextDirection();
      if (this.textDirection == "rtl") {
        this.checkTextAlign = "has-text-right";
      }

      this.appData = this.getAppData();

      if (this.appData != null) {
        if (this.appData.careGiver != null) {
          this.homeless = this.appData.careGiver.currentlyHomeless;
          this.otherLocation = this.appData.careGiver.searchOtherLocation;
          this.addressSuggestion = this.buildAddressSuggestion(this.appData);
          this.otherAddressSuggestion = this.buildOtherAddressSuggestion(
            this.appData
          );
          this.addressComponents.streetaddress = this.appData.careGiver.streetAddress;
          this.addressComponents.city = this.appData.careGiver.city;
          this.addressComponents.state = this.appData.careGiver.state;
          this.addressComponents.county = this.appData.careGiver.county;
          this.addressComponents.zipcode = this.appData.careGiver.zipCode;
          this.addressComponents.latitude = this.appData.careGiver.latitude;
          this.addressComponents.longitude = this.appData.careGiver.longitude;

          if (this.otherLocation === true) {
            this.otherAddressComponents.streetaddress = this.appData.careGiver.otherAddress;
            this.otherAddressComponents.city = this.appData.careGiver.otherCity;
            this.otherAddressComponents.state = this.appData.careGiver.otherState;
            this.otherAddressComponents.county = this.appData.careGiver.otherCounty;
            this.otherAddressComponents.zipcode = this.appData.careGiver.otherZip;
            this.otherAddressComponents.latitude = this.appData.careGiver.otherLatitude;
            this.otherAddressComponents.longitude = this.appData.careGiver.otherLongitude;
          }
        }
        await this.putWorkflowStep(this.appData.workflowId, "CareGiver2");
        this.$v.addressSuggestion.$touch()
        this.pageLoaded = true
      }
    } catch (error) {
      this.showError(error);
    }
  }

  buildAddressSuggestion(appData: AppData): string {
    let suggestion = "";

    if (appData != null) {
      const careGiver = appData.careGiver;
      if (
        appData.careGiver != null &&
        appData.careGiver.streetAddress != null
      ) {
        suggestion = `${careGiver.streetAddress} ${careGiver.city}, ${careGiver.state} ${appData.zipCode}`;
      }
    }

    return suggestion;
  }

  buildOtherAddressSuggestion(appData: AppData): string {
    let suggestion = "";

    if (appData != null) {
      const careGiver = appData.careGiver;
      if (
        appData.careGiver != null &&
        appData.careGiver.searchOtherLocation === true
      ) {
        suggestion = `${careGiver.otherAddress} ${careGiver.otherCity}, ${careGiver.otherState} ${careGiver.otherZip}`;
      }
    }

    return suggestion;
  }

  public handleNextPageEvent(): void {
    this.saveData();
    this.$router.push({ path: "CareGiver3" });
  }

  disableNext(): boolean {
    return this.$v.$invalid;
  }

  get haveEmailAddress(): boolean {
    return (
      this.appData.careGiver != null &&
      this.appData.careGiver.email != null &&
      this.appData.careGiver.email.length > 0
    );
  }

  @Watch("otherLocation")
  onOtherLocationChange(): void {
    if (this.otherLocation !== true) {
      this.otherAddressSuggestion = "";
    }
  }

  saveData(): void {
    if (this.appData == null) {
      this.appData = {} as AppData;
    }

    if (this.appData.careGiver == null) {
      this.appData.careGiver = {} as CareGiver;
    }

    this.appData.careGiver.currentlyHomeless = this.homeless;
    this.appData.careGiver.searchOtherLocation = this.otherLocation;

    if (this.addressComponents != null) {
      this.appData.careGiver.streetAddress = this.addressComponents.streetaddress;
      this.appData.careGiver.city = this.addressComponents.city;
      this.appData.careGiver.state = this.addressComponents.state;
      this.appData.careGiver.county = this.toValidCounty(this.addressComponents.county);
      this.appData.careGiver.latitude = this.addressComponents.latitude;
      this.appData.careGiver.longitude = this.addressComponents.longitude;
      this.appData.careGiver.zipCode = this.addressComponents.zipcode;

      if (this.otherLocation === true && this.otherAddressComponents) {
        this.appData.careGiver.otherAddress = this.otherAddressComponents.streetaddress;
        this.appData.careGiver.otherCity = this.otherAddressComponents.city;
        this.appData.careGiver.otherState = this.otherAddressComponents.state;
        this.appData.careGiver.otherCounty = this.toValidCounty(this.otherAddressComponents.county);
        this.appData.careGiver.otherZip = this.otherAddressComponents.zipcode;
        this.appData.careGiver.otherLatitude = this.otherAddressComponents.latitude;
        this.appData.careGiver.otherLongitude = this.otherAddressComponents.longitude;
      }
    }

    this.saveAppData(this.appData);
  }

  setAddress(place: any) {
    [this.addressComponents, this.addressIsComplete] = this.GooglePlaceToAddress(place);
    //console.log(JSON.stringify(this.addressComponents));

    // Maintain value in the addressSuggestion so the user can see what they have entered in the filter options
    this.addressSuggestion = (place.formatted_address || "").replace(
      ", USA",
      ""
    );
    //console.log(JSON.stringify(this.addressSuggestion));
  }

  setOtherAddress(place: any) {
    [this.otherAddressComponents, this.otherAddressIsComplete] = this.GooglePlaceToAddress(place);
    //console.log(JSON.stringify(this.otherAddressComponents));

    // Maintain value in the addressSuggestion so the user can see what they have entered in the filter options
    this.otherAddressSuggestion = (place.formatted_address || "").replace(
      ", USA",
      ""
    );
  }

  isWayneCounty( countyName: string): boolean {
    return countyName === "Wayne County"  || countyName === 'Wayne';
  }

}
